var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropdownWhiteClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ep:back"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.4901 9.74921L6.30638 4.56671C6.18902 4.44935 6.12309 4.29018 6.12309 4.12421C6.12309 3.95824 6.18902 3.79907 6.30638 3.68171C6.42374 3.56435 6.58291 3.49842 6.74888 3.49842C6.91485 3.49842 7.07402 3.56435 7.19138 3.68171L12.8164 9.30671C12.8746 9.36477 12.9208 9.43374 12.9523 9.50967C12.9838 9.5856 13 9.667 13 9.74921C13 9.83142 12.9838 9.91282 12.9523 9.98875C12.9208 10.0647 12.8746 10.1337 12.8164 10.1917L7.19138 15.8167C7.07402 15.9341 6.91485 16 6.74888 16C6.58291 16 6.42374 15.9341 6.30638 15.8167C6.18902 15.6994 6.12309 15.5402 6.12309 15.3742C6.12309 15.2082 6.18902 15.0491 6.30638 14.9317L11.4901 9.74921Z",
    fill: "#F0F0F0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownWhiteClose);
export default __webpack_public_path__ + "static/media/DropdownWhiteClose.712aeadafa379b30917c3d386cab0e44.svg";
export { ForwardRef as ReactComponent };